<template><div class="view" @keyup.enter="clickLogin">

	<main>		

		<div class="login-box" v-if="!forgotMode">

			<div class="field">
				<label>Username or Email</label>
				<input type="text" placeholder="Email" v-model="identity">				
			</div>

			<div class="field">
				<label>Password</label>
				<input type="password" placeholder="Password" v-model="password">				
			</div>

			<div class="btn btn-white shadowed" @click="clickForgotPassword()">Forgot password?</div> &nbsp;&nbsp;&nbsp; 
			<div class="btn btn-black" @click="clickLogin()">Login</div>
			
		</div>

		<div class="login-box" v-if="forgotMode">

			<div class="field">
				<label>Email</label>
				<input type="text" placeholder="Email" v-model="forgot_email">				
			</div>

			<div class="btn btn-black" @click="resetPassword()">Reset password</div>
			
		</div>

	</main>

</div></template>
<script>
import mixins from '.././mixins.js'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		
	},

	data(){ return {
			
		identity: '',
		password: '',

		forgot_email: '',
		
		forgotMode: false,

	}},

	computed: {

		

	},

	methods: {

		clickLogin(){

			var _this = this

			this.fetch( 'login', { a: btoa(this.identity), b: btoa(this.password), }, 
			{ onSuccess: function(output){
				
				if( output.error || !output.data.user ) {

					console.log('valid request, but missing data')												

					_this.msg('Login failed: '+output.error)

					return
				}

				_this.$store.commit('set_loggedin_user', output.data.user)
				
				var loc = '/admin'
				if( _this.is_site_am ) loc = '/'
				
				_this.$router.push(loc)
				

			}, onError: function(output){

				console.log('NAH - fetched but with error',output)		
				_this.msg('Login failed, try again...')

			}})

		},


		clickForgotPassword(){
			this.forgotMode = true
		},


		resetPassword(){
			
			var _this = this

			this.fetch( 'reset_password', { a: btoa(this.forgot_email), }, 
			{ onSuccess: function(output){

				if( output.error ) {
					_this.msg('Error, could not reset password...')
					return
				}
				
				_this.forgotMode = false
				_this.msg('Please check your email - you should now receive your new temporary password')				

			}, onError: function(output){

				_this.msg('Error, could not reset password...')

			}})

		},

	},

	created(){
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue